export function setupRem() {
  const MIN = 14
  const MAX = 20
  function apply() {
    const vw = Math.max(320, Math.min(window.innerWidth, 1200))
    const base = (vw / 375) * 16
    const clamped = Math.max(MIN, Math.min(MAX, base))
    document.documentElement.style.fontSize = `${clamped}px`
  }
  apply()
  window.addEventListener('resize', apply, { passive: true })
}
